import { InputEdit } from "components";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "utils/hooks";
import { GNSSOverview, Login } from "pages";

export function Home() {
  const { isUserAuthorized } = useAuth();
  const navigate = useNavigate();

  if (isUserAuthorized) navigate("/overview/dashboard");
  else navigate("/login");
}
